import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Menu, Divider } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  ShoppingOutlined,
  DollarCircleOutlined,
  ProfileOutlined,
  CheckCircleOutlined,
  LoginOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { AuthButtons as StyledAuthButtons } from '../Header.styles';

const AuthButtons = ({ showLoginModal }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  setUser(null);
  navigate('/'); // Điều hướng trước
  window.location.reload(); // Reload sau
};


  const menu = (
    <Menu>
      <Menu.Item key="profile" icon={<ProfileOutlined />}>
        <Link to="/information-customer">Thông tin cá nhân</Link>
      </Menu.Item>

      {user?.role === 'GymOwner' && (
        <Menu.Item key="gym-status" icon={<CheckCircleOutlined />}>
          <Link to="/gym-status">Trạng thái đăng ký</Link>
          {/* <Link to={`/gym-status?gymId=${gym.gymId}`}>Xem trạng thái</Link> */}

        </Menu.Item>
      )}



      {user?.role === 'GymOwner' && (
        <Menu.Item key="package-owner-list" icon={<ShoppingOutlined />}>
          <Link to="/package-owner-list">Gói đã mua</Link>
        </Menu.Item>
      )}

      {user?.role === 'GymOwner' && (
        <Menu.Item key="user-payment-orders" icon={<ShoppingOutlined />}>
          <Link to="/user-payment-orders">Gói đã đăng kí phòng Fitness</Link>
        </Menu.Item>
      )}

      {user?.role === 'Admin' && (
        <Menu.Item key="revenue-summary" icon={<DollarCircleOutlined />}>
          <Link to="/revenue-summary">Ví tổng</Link>
        </Menu.Item>
      )}
      {user?.role === 'Admin' && (
        <Menu.Item key="pending-gyms" icon={<DollarCircleOutlined />}>
          <Link to="/pending-gyms">Duyệt phòng Fitness</Link>
        </Menu.Item>
      )}

      <Divider style={{ margin: '8px 0' }} />

      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Đăng xuất
      </Menu.Item>
    </Menu>
  );

  return (
    <StyledAuthButtons className="auth-buttons">
      {user ? (
        <Dropdown overlay={menu} placement="bottomRight" arrow>
          <Button type="text" icon={<UserOutlined />}>
            Xin chào, {user.fullName || user.Email || user.email}
          </Button>
        </Dropdown>
      ) : (
        <>
          <Button type="link" icon={<LoginOutlined />} onClick={showLoginModal}>
            Đăng nhập
          </Button>
          <Button type="primary">
            <Link to="/register">Đăng ký</Link>
          </Button>
        </>
      )}
    </StyledAuthButtons>
  );
};

export default AuthButtons;
